if (!customElements.get('sticky-product-bar')) {
  customElements.define(
    'sticky-product-bar',
    class StickyProductBar extends HTMLElement {
      connectedCallback () {
        this.productInfo = this.closest('product-info')
        this.mainPurchaseRow = this.productInfo?.querySelector('.pdp-purchase-row')
        this.mainForm = this.productInfo?.querySelector('product-form')
        this.mainButton = this.mainForm?.querySelector('[name="add"]')
        this.variantInput = this.mainForm?.querySelector('[name="id"]')
        this.price = this.querySelector('[data-sticky-atc-price]')
        this.button = this.querySelector('.sticky-atc__button')
        this.buttonText = this.button?.querySelector('span')
        this.message = this.querySelector('.sticky-atc__message')
        this.footer = document.querySelector('.footer')
        this.drawer = document.querySelector('.js-go-cart-drawer')
        this.hasPassedMainAction = false
        this.isFooterVisible = false
        this.isResolvingVariant = false

        if (!this.productInfo || !this.mainPurchaseRow || !this.mainForm || !this.button) return

        this.button.addEventListener('click', this.handleAdd.bind(this))
        this.setupVisibilityObservers()
        this.setupStateObservers()
        this.syncFromMainForm()

        this.optionChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionChange.bind(this)
        )
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        )
      }

      disconnectedCallback () {
        this.mainActionObserver?.disconnect()
        this.footerObserver?.disconnect()
        this.drawerObserver?.disconnect()
        this.formObserver?.disconnect()
        this.optionChangeUnsubscriber?.()
        this.variantChangeUnsubscriber?.()
      }

      setupVisibilityObservers () {
        this.mainActionObserver = new IntersectionObserver(([entry]) => {
          this.hasPassedMainAction = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0
          this.updateVisibility()
        })
        this.mainActionObserver.observe(this.mainPurchaseRow)

        if (this.footer) {
          this.footerObserver = new IntersectionObserver(([entry]) => {
            this.isFooterVisible = entry.isIntersecting
            this.updateVisibility()
          })
          this.footerObserver.observe(this.footer)
        }
      }

      setupStateObservers () {
        this.drawerObserver = new MutationObserver(() => this.updateVisibility())
        this.drawerObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] })

        if (this.drawer) {
          this.drawerObserver.observe(this.drawer, { attributes: true, attributeFilter: ['class'] })
        }

        if (this.mainButton) {
          this.formObserver = new MutationObserver(() => this.syncFromMainForm())
          this.formObserver.observe(this.mainButton, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class']
          })
        }
      }

      handleOptionChange ({ data }) {
        if (!this.productInfo.contains(data.event.target)) return

        this.isResolvingVariant = true
        this.hideMessage()
        this.syncFromMainForm()
      }

      handleVariantChange ({ data }) {
        if (data.sectionId !== this.dataset.sectionId) return

        this.isResolvingVariant = false
        this.syncFromMainForm()
      }

      syncFromMainForm () {
        const mainPrice = this.productInfo.querySelector('[data-testid="pdp-actual-price"]')
        const variantId = this.variantInput?.value
        const isSoldOut = Boolean(variantId) && this.mainButton?.hasAttribute('disabled')
        const isBusy = this.isResolvingVariant || this.mainButton?.getAttribute('aria-disabled') === 'true'

        if (mainPrice && this.price) this.price.textContent = mainPrice.textContent

        this.button.disabled = isSoldOut || isBusy
        this.button.toggleAttribute('aria-busy', isBusy)
        this.button.classList.toggle('button--primary', !isSoldOut)
        this.button.classList.toggle('button--sold-out', isSoldOut)

        if (this.buttonText) {
          this.buttonText.textContent = isSoldOut
            ? this.button.dataset.soldOutText
            : this.button.dataset.addToCartText
        }
      }

      handleAdd () {
        if (this.isResolvingVariant) return

        if (!this.variantInput?.value) {
          this.showOptionPrompt()
          return
        }

        if (this.mainButton?.hasAttribute('disabled')) return

        this.hideMessage()
        this.mainButton?.click()
      }

      showOptionPrompt () {
        if (this.message) this.message.hidden = false
        this.button.setAttribute('aria-invalid', 'true')

        const variantPicker = this.productInfo.querySelector('variant-selects')
        variantPicker?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        variantPicker?.querySelector('select, input:not([disabled])')?.focus({ preventScroll: true })
      }

      hideMessage () {
        if (this.message) this.message.hidden = true
        this.button.removeAttribute('aria-invalid')
      }

      updateVisibility () {
        const drawerIsOpen = document.body.classList.contains('drawer-open') || this.drawer?.classList.contains('is-open')
        this.classList.toggle('is-visible', this.hasPassedMainAction && !this.isFooterVisible && !drawerIsOpen)
      }
    }
  )
}
